<app-error-template
  *ngIf="!comments"
  [type]="'empty'"
  [bodyMessage]="'There are no comments' | transloco"
></app-error-template>
<div class="flex sm:flex-row flex-col w-full gap-3" *ngIf="comments">
  <div *ngIf="logs" class="flex" [ngClass]="type === 'note' ? 'w-full' : 'w-1/2'">
    <!-- Show loading state while custom fields are being loaded -->
    <div *ngIf="isLoadingCustomFields" class="w-full flex items-center justify-center p-4">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <!-- Show logs once custom fields are loaded (or if no custom fields) -->
    <app-logs
      *ngIf="!isLoadingCustomFields"
      class="max-h-200 overflow-y-scroll w-full"
      [logs]="logs"
      [customFields]="customFields"
    ></app-logs>
  </div>
  <div
    *ngIf="(type !== 'note' || !type) && !hideComments"
    [ngClass]="logs?.length ? 'md:w-full' : 'w-full'"
    class="break-before-auto border rounded-lg p-2"
  >
    <h4 class="card-title text-lg text-primary mb-2">
      {{ 'Comments' | transloco }}
      <span *ngIf="type" class="text-secondary">{{
        ' ' + '(' + comments?.replies?.length + ')'
      }}</span>
    </h4>
    <div class="flex flex-col w-full">
      <div class="w-full darken-bg">
        <!-- The Replay Form-->
        <div
          *ngIf="replyPermission && id && replyForm"
          [class.is-loading]="loading"
          class="px-3 pt-3 w-full rounded-md bg-accent-800 print:hidden"
        >
          <form *ngIf="!comments?.deleted_at" [formGroup]="replyForm" class="example-form">
            <mat-form-field
              id="replyField"
              [ngClass]="{
                'placeholder-invalid':
                  replyForm.get('reply').invalid && replyForm.get('reply').touched
              }"
              class="w-full"
            >
              <div class="flex flex-col w-full">
                <div>
                  <textarea
                    id="reply"
                    (input)="onSearchInputChange($event.target.value)"
                    (click)="onTextareaFocus()"
                    [matAutocomplete]="auto"
                    [ngClass]="{
                      'placeholder-invalid':
                        replyForm.get('reply').invalid && replyForm.get('reply').touched
                    }"
                    [placeholder]="'Your Comment:' | transloco"
                    formControlName="reply"
                    matInput
                  >
                  </textarea>
                </div>
                <div>
                  <span *ngIf="userMentioned.length" class="text-sm text-secondary">{{
                    'Mentions' | transloco
                  }}</span>
                  <mat-chip-list formArrayName="chips">
                    <mat-chip
                      *ngFor="let chip of replyForm.get('chips').controls; let i = index"
                      [formControlName]="i"
                      class="text-sm"
                      matTooltip="{{ chip.value }}"
                      style="min-height: 20px"
                    >
                      {{ chip.value }}
                      <mat-icon (click)="removeChip(i)" matChipRemove svgIcon="cancel"></mat-icon>
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
            </mat-form-field>

            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onUserSelected($event.option.value)"
            >
              <ng-container *ngIf="mentionedUserTriggered">
                <mat-option *ngFor="let user of mentionableUsersList" [value]="'@' + user.email">
                  <div class="circle">
                    <span class="initials">{{ getUserInitials(user) }}</span>
                  </div>
                  <span [ngClass]="{ mention: userSelected === user }" class="text-secondary"
                    >{{ user.name }} | {{ user.email }}</span
                  >
                </mat-option>
              </ng-container>
            </mat-autocomplete>

            <app-file-uploader
              (filesList)="attachments = $event"
              *ngIf="isUploadShown"
              [multiple]="true"
              [options]="fileOptions"
              [state]="isUploadShown"
              [cashedFiles]="attachments"
            >
            </app-file-uploader>

            <div class="actions text-center">
              <mat-divider></mat-divider>
              <div class="flex flex-row justify-between items-center p-3">
                <button
                  (click)="isUploadShown = !isUploadShown"
                  [class.bg-accent-700]="isUploadShown"
                  [matTooltip]="'Upload Files' | transloco"
                  class="p-0 rounded-md"
                  mat-button
                  matTooltipPosition="above"
                  style="min-width: 35px; height: 30px; min-height: 30px"
                  type="submit"
                >
                  <mat-icon class="icon-size-5" svgIcon="upload"></mat-icon>
                </button>
                <button
                  (click)="sendReply()"
                  [disabled]="replyForm.invalid"
                  [matTooltip]="'Add Comment' | transloco"
                  class="px-3"
                  color="primary"
                  mat-flat-button
                  matTooltipPosition="above"
                  style="min-height: 30px; height: 30px"
                  type="submit"
                >
                  {{ 'send' | transloco }}
                  <mat-icon
                    *ngIf="('lang' | transloco) !== 'ar'"
                    class="icon-size-5 ms-2 -me-1"
                    svgIcon="send"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="('lang' | transloco) === 'ar'"
                    class="icon-size-5 ps-1 ms-0"
                    style="transform: rotate(180deg)"
                    svgIcon="send"
                  >
                  </mat-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
        <!-- the list of replies -->
        <div class="max-h-140 overflow-y-auto print:max-h-none print:overflow-visible">
          <app-error-template
            *ngIf="observationReplies?.length === 0"
            [type]="'empty'"
            [bodyMessage]="'No Comments Yet' | transloco"
          ></app-error-template>
          <div
            *ngFor="let item of observationReplies"
            class="px-3 py-2 border-b"
            [id]="'comment-' + (item.id ? item?.id : item?.reply_id)"
          >
            <div class="flex flex-row items-center justify-between mb-2">
              <div class="flex flex-row items-center space-x-2">
                <div
                  [matTooltip]="item.replied_by"
                  [ngClass]="_transloco.getActiveLang() === 'ar' ? 'me-2' : ''"
                  class="rounded-full w-8 h-8 min-w-8 min-h-8 flex items-center justify-center bg-primary text-white"
                >
                  {{ item.replied_by.charAt(0).toUpperCase() }}
                </div>
                <div>
                  <div class="text-sm font-medium text-primary">
                    {{ item.replied_by | titlecase }}
                  </div>
                  <div
                    [innerHTML]="item.replied_at | dateTransform"
                    class="text-xs text-secondary"
                  ></div>
                  <div class="flex flex-wrap text-sm" style="overflow-wrap: anywhere">
                    {{ item.text_reply }}
                    <ng-container *ngFor="let mention of item.mentions">
                      <mat-chip
                        [matTooltip]="mention.email"
                        [ngStyle]="{
                          'background-color':
                            mention?.status === 'Inactive'
                              ? 'rgb(100 116 139 / var(--tw-bg-opacity))'
                              : mention?.status === 'Active'
                              ? 'rgb(34 197 94 / var(--tw-bg-opacity))'
                              : mention?.status === 'Deactivated'
                              ? 'rgb(249 115 22 / var(--tw-bg-opacity))'
                              : mention?.status === 'Expired'
                              ? 'rgb(239 68 68 / var(--tw-bg-opacity))'
                              : ''
                        }"
                        class="mx-1 rounded text-sm"
                        style="min-height: 14px"
                      >
                        {{ mention.name | titlecase }}
                        <span class="ms-1">({{ mention.status | titlecase }} )</span>
                      </mat-chip>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="item?.reply_attached?.length > 0" class="mt-2">
              <div class="flex flex-row flex-wrap items-center gap-2">
                <div class="text-xs text-secondary ms-2">
                  {{ 'Attachments' | transloco }}
                  :
                </div>
                <div
                  *ngIf="item?.reply_attached?.length > 0"
                  class="w-full p-2 mb-2 darker-bg rounded-md flex flex-wrap justify-start"
                >
                  <button
                    (click)="openPreviewer(attache.path, attache.extension, attache.file_name)"
                    *ngFor="let attache of item.reply_attached"
                    class="relative hover:opacity-70 mx-1 transition-all bg-accent-800 flex justify-center rounded-md"
                    style="min-width: 4.5rem"
                  >
                    <!-- Preview based on file type -->
                    <ng-container [ngSwitch]="attache.extension.toLowerCase()">
                      <!-- Image Preview -->
                      <ng-container *ngSwitchCase="'jpg'">
                        <img
                          [src]="attache.path"
                          alt="attache.file_name"
                          class="h-15 w-auto rounded-md"
                        />
                      </ng-container>

                      <ng-container *ngSwitchCase="'jpeg'">
                        <img
                          [src]="attache.path"
                          alt="attache.file_name"
                          class="h-15 w-auto rounded-md"
                        />
                      </ng-container>

                      <ng-container *ngSwitchCase="'png'">
                        <img
                          [src]="attache.path"
                          alt="attache.file_name"
                          class="h-15 w-auto rounded-md"
                        />
                      </ng-container>

                      <ng-container *ngSwitchCase="'gif'">
                        <img
                          [src]="attache.path"
                          alt="attache.file_name"
                          class="h-15 w-auto rounded-md"
                        />
                      </ng-container>

                      <!-- PDF Placeholder -->
                      <ng-container *ngSwitchCase="'pdf'">
                        <img
                          [src]="'/assets/images/file_pdf.png'"
                          alt="attache.file_name"
                          class="h-15 w-auto rounded-md"
                        />
                      </ng-container>

                      <!-- MP4 Placeholder -->
                      <ng-container *ngSwitchCase="'mp4'">
                        <img
                          [src]="'/assets/images/file_mp4.png'"
                          alt="attache.file_name"
                          class="h-15 w-auto rounded-md"
                        />
                      </ng-container>

                      <!-- Default Case -->
                      <ng-container *ngSwitchDefault>
                        <div class="flex h-15 w-auto rounded-md items-center">
                          <mat-icon svgIcon="document_scanner"></mat-icon>
                        </div>
                      </ng-container>
                    </ng-container>

                    <!-- Download Icon (Separate Functionality) -->
                    <mat-icon
                      (click)="downloadFile(attache); $event.stopPropagation()"
                      class="mat-icon absolute z-20 top-1 right-1 icon-size-4 text-white"
                      svgIcon="mat_solid:download"
                      style="cursor: pointer"
                    >
                    </mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
</div>
